import React, { useContext } from "react";
import { AppContext } from "../../App";
import Can from "../can/Can";
import { default as ClientBatchesDetailsContainer } from "./client/BatchesDetailsContainer";
import { default as AdminBatchesDetailsContainer } from "./admin/BatchesDetailsContainer";
import { batches } from "../../rbac-consts";

const BatchesDetailsWrapper = ({ match }) => {

  const { user } = useContext(AppContext);

  return (
    <>
      <Can
        role={user.roles}
        perform={batches.USER}
        yes={() => (
          <ClientBatchesDetailsContainer match={match} />
        )}
      />
      <Can
        role={user.roles}
        perform={batches.ADMIN}
        yes={() => (
          <AdminBatchesDetailsContainer match={match} />
        )}
      />
    </>
  );
};

export default BatchesDetailsWrapper;